import React, { useEffect, useState } from "react";
import Axios from "middleware/axiosInstance";
import { Link, useParams } from "react-router-dom";
import checkTik from "assets/images/wareHouse-icons/accept-check.svg";
import blackTik from "assets/images/wareHouse-icons/tick-icon.svg";
import ButtonComponent from "components/Form/ButtonComponent";

const ShowCommodityAndServicesDetails = () => {
  // start react router url params
  const UrlParams = useParams();
  const commodityId = UrlParams.id;
  // end react router url params
  const [commodity, setCommodity] = useState(null);
  const [currentCount, setCurrentCount] = useState([]);


  const getDocInfo = () => {
    Axios.get(`/commodity/${commodityId}`)
      .then((res) => {
        setCommodity(res.data);
      })
      .catch((err) => console.log(err));
  };


  useEffect(() => {
    getDocInfo();
    getCurrentCountOfCommodityInAllWareHouse();
  }, []);


  const getCurrentCountOfCommodityInAllWareHouse = () => {
    Axios.post(`/count_commodity/${commodityId}`, "")
      .then((res) => setCurrentCount(res.data))
      .catch((err) => console.log(err));
  };


  return (
    <div className="customized-container">
      <div className="customized-wrapper">
        <h5 className="title-session">جزییات کالا</h5>
        <div className="d-flex flex-row ">
          <Link to={`/warehouse/edit-commodity-and-services/${commodityId}`}>
            <ButtonComponent value="ویرایش" />
          </Link>
          <Link to="/warehouse/commodity-and-services">
            <button className="bi-custom-button btn-sm">بازگشت</button>
          </Link>
        </div>
        {commodity && (
          <div className="d-flex flex-column w-100">
            <h5 className="me-3 mt-2">
              <img
                width={25}
                src={checkTik}
                className="ms-1"
                alt=""
                srcset=""
              />
              کالا و گروه کالایی
            </h5>
            <table className="bi-table-style w-100">
              <thead>
                <tr>
                  <th>گروه کالایی</th>
                  <th>شناسه</th>
                  <th>نام کالا</th>
                  <th>واحد اندازه گیری</th>
                  <th>نحوه رهگیری</th>
                  <th>قابل مرجوع</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{commodity.goods_name}</td>
                  <td>{commodity.shenaseh}</td>
                  <td>{commodity.name}</td>
                  <td>{commodity.unit_name}</td>
                  <td>
                    {commodity.delivery === "bedon_rahgiri"
                      ? "بدون رهگیری"
                      : commodity.delivery === "serial"
                        ? "سریال"
                        : "- - -"}
                  </td>
                  <td>{commodity.returnable === 1 ? "بلی" : "خیر"}</td>
                </tr>
              </tbody>
            </table>

            <h5 className="me-3 mt-4">
              <img
                width={25}
                src={checkTik}
                className="ms-1"
                alt=""
                srcset=""
              />
              میزان موجودی این کالا در انبار ها
            </h5>
            <table className="bi-table-style w-100">
              <thead>
                <tr>
                  <th>
                    نام انبار
                  </th>
                  <th>
                    مقدار ورودی
                  </th>
                  <th>
                    مقدار خروجی
                  </th>
                </tr>
              </thead>
              <tbody>
                {currentCount?.map((warehouse) => {
                  return (
                    <tr>
                      <td>
                        {warehouse.anbar.name}
                      </td>
                      <td>
                        {warehouse.count_im}
                      </td>
                      <td>
                        {warehouse.count_ex}
                      </td>
                      {
                        // if "count_im" and "count_ex" is number minus that and return , else is not a number
                        isNaN(warehouse.count_im) && isNaN(warehouse.count_ex) ?
                          "- - -" : warehouse.count_im - warehouse.count_ex}
                    </tr>
                  )
                })}
              </tbody>
            </table>


            <h5 className="me-3 mt-4">
              <img
                width={25}
                src={checkTik}
                className="ms-1"
                alt=""
                srcset=""
              />
              قیمت و ارزش افزوده
            </h5>
            <table className="bi-table-style w-100">
              <thead>
                <tr>
                  <th>ارزش افزوده</th>
                  <th>محاسبه ارزش افزوده در قیمت</th>
                  <th>نوع بارکد</th>
                  <th>شماره بارکد</th>
                  <th>قیمت فروش</th>
                  <th>قیمت خرید</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    {commodity.arzesh_afzoode === "nadarad" ? "ندارد" : "دارد"}
                  </td>
                  <td>{commodity.mohasebeh === 1 ? "بلی" : "خیر"}</td>
                  <td>
                    {commodity.barcode_type === "barcode_weight"
                      ? "وزنی"
                      : "تعدادی"}
                  </td>
                  <td>{commodity.barcode}</td>
                  <td>{commodity.sales_price}</td>
                  <td>{commodity.buy_price}</td>
                </tr>
              </tbody>
            </table>
            <h5 className="me-3 mt-4">
              <img
                width={25}
                src={checkTik}
                className="ms-1"
                alt=""
                srcset=""
              />
              اطلاعات کالا
            </h5>
            <table className="bi-table-style w-100">
              <thead>
                <tr>
                  <th>نقطه سفارش</th>
                  <th>مقدار سفارش</th>
                  <th>قفسه</th>
                  <th>مدل</th>
                  <th>سازنده</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{commodity.order_point}</td>
                  <td>{commodity.order_amount}</td>
                  <td>{commodity.shelf}</td>
                  <td>{commodity.model}</td>
                  <td>{commodity.manufacturer}</td>
                </tr>
              </tbody>
            </table>
            {commodity.description &&
              <>
                <h5 className="me-3 mt-4">
                  <img
                    width={25}
                    src={checkTik}
                    className="ms-1"
                    alt=""
                    srcset=""
                  />
                  توضیحات
                </h5>
                <table className="bi-table-style w-100">
                  <thead>
                    <tr>
                      <th>توضیحات</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{commodity.description || "توضیحات ندارد"}</td>
                    </tr>
                  </tbody>
                </table>
              </>
            }
            {commodity.features && (
              <>
                <h5 className="me-3 mt-4">
                  <img
                    width={25}
                    src={checkTik}
                    className="ms-1"
                    alt="#"
                    srcset=""
                  />
                  ویژگی های محصول
                </h5>
                <table className="bi-table-style w-100">
                  <thead>
                    <tr>
                      <th>ردیف</th>
                      <th>نام ویژگی</th>
                      <th>مقدار ویژگی</th>
                    </tr>
                  </thead>
                  <tbody>
                    {commodity.features.map((item, index) => {
                      return (
                        <tr>
                          <td>{index + 1}</td>
                          <td>{item.name}</td>
                          <td>{item.amounts}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </>
            )}
            {commodity.sub_unit && (
              <>
                <h5 className="me-3 mt-4">
                  <img
                    width={25}
                    src={checkTik}
                    className="ms-1"
                    alt="#"
                    srcset=""
                  />
                  واحد های متفرقه
                </h5>
                <ul className="me-5">
                  {commodity.sub_unit.map((item) => {
                    return (
                      <li>
                        <img
                          width={17}
                          src={blackTik}
                          className="ms-1"
                          alt="#"
                          srcset=""
                        />
                        {`
                                هر
                                ${item.each}
                                برابر است با یک
                                ${item.unit}
                                `}
                      </li>
                    );
                  })}
                </ul>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
export default ShowCommodityAndServicesDetails;